import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomepageSlidersList } from './components/HomepageSlidersList';
import { HomepageSliderForm } from './components/HomepageSliderForm';
import SingleHomepageSlide from './single';

const HomepageSlidersRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<HomepageSlidersList />} />
      <Route path='create' element={<HomepageSliderForm />} />
      <Route path='edit/:id' element={<HomepageSliderForm />} />
      <Route path=':id' element={<SingleHomepageSlide />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default HomepageSlidersRoutes; 